import { actions } from './actions'

const initialState = {
  consultaEmails: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function consultaEmailsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CONSULTA_EMAILS_LOAD_REQUESTED:
      return { ...state, consultaEmails: { ...state.consultaEmails, loading: true } }
    case actions.CONSULTA_EMAILS_LOAD_SUCCEEDED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, data: action.payload, loading: false },
      }
    case actions.CONSULTA_EMAILS_LOAD_FILED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, loading: false, error: action.error },
      }
    case actions.CONSULTA_EMAIL_UPDATE_REQUESTED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, loading: true, error: '' },
      }
    case actions.CONSULTA_EMAIL_UPDATE_SUCCEEDED:
      return {
        ...state,
        consultaEmails: {
          ...state.consultaEmails,
          data: state.consultaEmails.data.map(mail =>
            mail.id === action.payload.id ? action.payload : mail,
          ),
          loading: false,
          error: '',
        },
      }
    case actions.CONSULTA_EMAIL_UPDATE_FILED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, loading: false, error: action.error },
      }
    case actions.CONSULTA_EMAIL_INSERT_REQUESTED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, loading: true, error: '' },
      }
    case actions.CONSULTA_EMAIL_INSERT_SUCCEEDED:
      return {
        ...state,
        consultaEmails: {
          ...state.consultaEmails,
          data: [].concat(action.payload, state.consultaEmails.data),
          loading: false,
          error: '',
        },
      }
    case actions.CONSULTA_EMAIL_INSERT_FILED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, loading: false, error: action.error },
      }
    case actions.CONSULTA_EMAIL_DELETE_REQUESTED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, loading: true, error: '' },
      }
    case actions.CONSULTA_EMAIL_DELETE_SUCCEEDED:
      return {
        ...state,
        consultaEmails: {
          ...state.consultaEmails,
          data: state.consultaEmails.data.filter(mail => mail.id !== action.payload),
          loading: false,
          error: '',
        },
      }
    case actions.CONSULTA_EMAIL_DELETE_FILED:
      return {
        ...state,
        consultaEmails: { ...state.consultaEmails, loading: false, error: action.error },
      }
    default:
      return state
  }
}
